import script from "./Copy.vue?vue&type=script&lang=tsx"
export * from "./Copy.vue?vue&type=script&lang=tsx"

import "./Copy.vue?vue&type=style&index=0&id=7edc0610&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7edc0610"]])

export default __exports__